import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

import {
  IconButton as MuiIconButton,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import useAuth from "../../hooks/useAuth";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Flag = styled.img`
  border-radius: 50%;
  width: 22px;
  height: 22px;
`;

type themeOptionsType = {
  [key: string]: {
    img: string;
    name: string;
    theme: any;
  };
};

function SubscriptionInfo() {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <React.Fragment>
      {user?.account ? (
        <Grid container gap={2} alignItems="center">
          <Typography>
            {t("subscriptionInfo", {
              count: user?.account?.contractsRemaining,
            })}
          </Typography>
          <Button
            href="https://gobeyondprocurement.outseta.com/profile?tab=planChange&stateProps=%7B%22planUid%22%3A%221QpG5gmE%22%2C%22planPaymentTerm%22%3A%22annual%22%7D#o-authenticated"
            variant="contained"
            size="small"
          >
            {t("Upgrade")}
          </Button>
        </Grid>
      ) : (
        <span />
      )}
    </React.Fragment>
  );
}

export default SubscriptionInfo;
